import axios from 'axios';

const DETAIL_PNR_URI = 'checkout/api/v2/booking/';

export function detailPnr(pnrId) { 
  return new Promise((resolve, reject) => {
    const URI_PATH = DETAIL_PNR_URI + pnrId;
    axios
      .get(URI_PATH, {
				headers: {
					fetchStatus: true
				}
			})
      .then(res => resolve(res))
      .catch(err => {
        reject(err);
      });
  });
}


// WEBPACK FOOTER //
// ./src/services/detail/DetailPnrService.js